import alertReducer from 'common/alerts/containers/alert-reducer';
import dashboardReducer from 'common/dashboard/containers/dashboard-reducer';
import documentReducer from 'common/documents/containers/documents-reducer';
import ganttReducer from 'common/gantt/containers/gantt-reducers';
import messageCenterReducer from 'common/message-center/containers/message-center-reducers';
import navigationReducer from 'common/navigation/containers/navigation-reducer';
import newsReducer from 'common/news/containers/news-reducer';
import publishStepsReducer from 'common/publish-steps/containers/publish-steps-reducer';
import referenceDataReducer from 'common/reference-data/containers/reference-data-reducer';
import timelineReducer from 'common/timeline/containers/timeline-reducer';
import dynamicToolbarReducer from 'common/toolbar/containers/toolbar-dynamic-actions-reducer';
import translationModalReducer from 'common/translate/containers/translation-modal-reducers';
import userReducer from 'common/user/containers/user-reducer';
import usersReducer from 'common/users/containers/users-dropdown-reducers';
import customerReducer from 'customer/customer-reducers';
import draftReducer from 'drafts/containers/draft-reducers';
import equipmentReducer from 'equipment/equipment-reducers';
import headerReducer from 'header/header/containers/header-reducers';
import systemMessageReducer from 'header/system-message/containers/system-message-reducers';
import uploadXMLReducer from 'header/upload-xml/containers/upload-xml-reducer';
import installedAtReducer from 'installed-at/installed-at-reducers';
import languageProviderReducer from 'language-provider/containers/language-provider-reducers';
import notificationCallReducer from 'notification_call/containers/notification_call-reducer';
import orderReducer from 'order/order-reducers';
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import searchReducer from 'search/containers/search-reducer';
import userManagementReducer from 'settings/containers/user-management/user-management-reducer';
import themeManagerReducer from 'theme-manager/containers/theme-manager-reducer';
import ticketFormReducer from 'tickets/containers/form/ticket-form-reducers';
import worklistReducer from 'worklist/containers/worklist-reducers';
// eslint-disable-next-line
import smartActionReducer from 'tickets/containers/smart-action-sidepanel/smart-action-sidepanel-reducers';
// eslint-disable-next-line
import serviceCenterToggleReducers from 'header/service-center-toggle/containers/service-center-toggle-reducers';
import planningBoardReducer from 'planning-board/containers/planning-board-reducers';
import absenceReducer from 'settings/containers/absence/absence-reducer';
// eslint-disable-next-line
import filterReducers from './modules/common/filters/entity-filter/containers/entity-filter-reducers';
import geoFilterReducers from './modules/common/filters/geo-filter/containers/geo-filter-reducers';
import workingHoursReducer from './modules/settings/containers/working-hours/working-hours-reducer';
// eslint-disable-next-line
import directRoutesHandlerReducers from './modules/direct/containers/direct-routes-handler-reducers';
import landingZoneReducer from './modules/home/containers/landing-zone/landing-zone-reducer';
import powerBiReportsReducers from './modules/power-bi/containers/power-bi-reducers';
import skillsReducers from './modules/settings/containers/skills/skills-reducers';
// eslint-disable-next-line
import announcementsReducers from './modules/settings/containers/announcements/announcements-reducers';
import campaignsReducers from './modules/settings/containers/campaigns/campaigns-reducers';
// eslint-disable-next-line
import customerCenterConfigurationReducers from './modules/settings/containers/customer-center-configuration/customer-center-configuration-reducer';
// eslint-disable-next-line
import standaloneModeReducers from './modules/settings/containers/standalone-mode/standalone-mode-reducers';
import wipCodesReducer from './modules/settings/containers/wip-codes/wip-codes-reducer';
import socketReducers from './modules/sockets/containers/socket-reducers';
// eslint-disable-next-line max-len
import functionalLocationReducers from './modules/functional-location/functional-location-reducers';

const rootReducer = combineReducers({
  search: searchReducer,
  ticketForm: ticketFormReducer,
  languageProvider: languageProviderReducer,
  form: formReducer,
  theme: themeManagerReducer,
  user: userReducer,
  installedAt: installedAtReducer,
  timeline: timelineReducer,
  dashboard: dashboardReducer,
  alert: alertReducer,
  navigation: navigationReducer,
  order: orderReducer,
  systemMessage: systemMessageReducer,
  equipment: equipmentReducer,
  customer: customerReducer,
  referenceData: referenceDataReducer,
  worklist: worklistReducer,
  messageCenter: messageCenterReducer,
  drafts: draftReducer,
  dynamicToolbar: dynamicToolbarReducer,
  uploadXML: uploadXMLReducer,
  users: usersReducer,
  documents: documentReducer,
  news: newsReducer,
  notification_call: notificationCallReducer,
  currentStatus: publishStepsReducer,
  header: headerReducer,
  translator: translationModalReducer,
  smartAction: smartActionReducer,
  userManagement: userManagementReducer,
  serviceCenter: serviceCenterToggleReducers,
  customerCenterConfiguration: customerCenterConfigurationReducers,
  planningBoard: planningBoardReducer,
  gantt: ganttReducer,
  absence: absenceReducer,
  filters: filterReducers,
  workingHours: workingHoursReducer,
  direct: directRoutesHandlerReducers,
  landingZone: landingZoneReducer,
  skills: skillsReducers,
  announcements: announcementsReducers,
  standaloneMode: standaloneModeReducers,
  powerBiReports: powerBiReportsReducers,
  geofilter: geoFilterReducers,
  campaigns: campaignsReducers,
  wipCodes: wipCodesReducer,
  sockets: socketReducers,
  functionalLocations: functionalLocationReducers,
});

export default rootReducer;
